export const components = {
  Modal: {
    baseStyle: {
      dialogContainer: {
        px: '20px',
      },
    },
  },
  Radio: {
    variants: {
      'source-select': {
        label: {
          width: '100%',
        },
        control: {
          marginTop: '10px',
        },
      },
      'source-select-selected': {
        label: {
          width: '100%',
        },
        control: {
          marginTop: '10px',
        },
        container: {
          backgroundColor: 'brand.primary.50',
        },
      },
    },
  },
  Drawer: {
    sizes: {
      xs: {
        dialog: { maxWidth: '370px' },
      },
    },
  },
}
